export default __webpack_public_path__ + "static/media/furniture.f7680d04.jpg";